<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-content">
        <div class="w-full p-6 bg-white shadow-lg rounded-lg">

          <div class="flex flex-col gap-8">

            <div class="flex flex-col gap-3 w-max">
              <h3 class="text-bluish-gray">Driver logs</h3>
              <div class="flex items-center border border-solid rounded-lg border-black px-3 py-2">
                <calendar-icon class="mr-2 w-5" />
                <span>{{ formatDateRange }}</span>
              </div>
            </div>

            <div>
              <vs-table class="border-0 border-solid border-t border-silver-gray" ref="table"
                :max-items="tableData.length" v-if="tableData && tableData.length" :data="tableData || []">
                <template slot="thead">
                  <vs-th v-for="(header, idx) in headers" :key="idx" class="text-black font-semibold text-sm">
                    {{ header }}
                  </vs-th>
                </template>
                <template v-if="tableData && tableData.length">
                  <tbody>
                    <vs-tr v-for="(tr, indextr) in tableData" :key="indextr"
                      :class="[indextr % 2 === 0 ? 'bg-soft-gray' : '']">
                      <vs-td>
                        {{ indextr + 1 }}
                      </vs-td>
                      <vs-td>
                        {{ tr.details[0].date }}
                      </vs-td>
                      <vs-td>
                        {{ tr.details[0].start }}
                      </vs-td>
                      <vs-td>
                        {{ tr.details[0].duration }}
                      </vs-td>
                      <vs-td>
                        {{ tr.details[0].location }}
                      </vs-td>
                      <vs-td>
                        {{ tr.details[0].odometer }}
                      </vs-td>
                      <vs-td>
                        {{ tr.details[0].engine_hours }}
                      </vs-td>
                      <vs-td>
                        <!-- {{ tr.details }} -->
                        {{ 1 + 1 }}
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>

            <div class="flex gap-3 self-end">
              <vs-button @click="download" class=" bg-soft-blue text-bold-blue">
                Download csv
              </vs-button>
              <vs-button @click="printPage">
                Print
              </vs-button>
              <vs-button @click="cancel" class="bg-pale-gray text-bluish-gray">
                Close
              </vs-button>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { CalendarIcon } from 'vue-feather-icons';
import moment from 'moment';

export default {
  components: {
    CalendarIcon
  },
  props: {
    tableData: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      headers: ['#', 'DATE', 'START', 'DURATION', 'LOCATION', 'ODOMETER', 'END.HOURS', 'DOCUMENT'],
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    printPage() {
      window.print();
    },
    download() {
      this.$vs.loading()
      this.$store.dispatch('activityReports/downloadFile', { download: 'excel', type: this.$store.state.activityReports.table.report_type })
        .finally(res => this.$vs.loading.close())
    }
  },
  computed: {
    formatDateRange() {
      const today = moment();
      const lastWeek = moment().subtract(7, 'days');
      return `${lastWeek.format('MM-DD-YYYY')} → ${today.format('MM-DD-YYYY')}`;
    },
  },

}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  z-index: 1000;
  opacity: 0;
  animation: fadeIn 0.3s forwards;
}


::v-deep .custom-multiple-select .vs__selected-options {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
}

::v-deep .custom-multiple-select .vs__selected-options::-webkit-scrollbar {
  height: 2px;
}

::v-deep .custom-multiple-select .vs__selected-options::-webkit-scrollbar-thumb {
  background-color: #a0a0a0;
  /* Color of the scrollbar thumb */
  border-radius: 0px;
}

::v-deep .custom-multiple-select .vs__selected-options::-webkit-scrollbar-track {
  background-color: #f0f0f0;
  /* Color of the scrollbar track */
}

.modal-container {
  position: relative;
  top: 7%;
  width: 100%;
  max-width: 80dvw;
  border-radius: 8px;
  transform: translateY(-100%);
  animation: slideIn 0.5s forwards ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-100%);
  }

  to {
    transform: translateY(0);
  }
}
</style>
